import React from 'react';
import CierreDiaADia from '../../../components/Cierre/CierreDiaADia';

const DiaADiaPage = () => {
  return <CierreDiaADia />;
};

export default DiaADiaPage;
